module.exports = __webpack_public_path__ + "img/service-4.444d0aa5.png";